<template>
  <div class="grid-cards-item">
    <div class="grid-cards-item-header">
      <div class="grid-cards-item-header-left-contents">
        <div class="grid-cards-item-header-left-contents-case-id">
          <span
            v-if="item?.mlPredictionOutcome === true"
            class="grid-cards-item-header-left-contents-case-id--ml-prediction-positive">
            OHP Dispute ID:
          </span>
          <span
            v-else-if="item?.mlPredictionOutcome === false"
            class="grid-cards-item-header-left-contents-case-id--ml-prediction-negetive">
            OHP Dispute ID:
          </span>
          <span v-else> OHP Dispute ID: </span>
          <router-link
            class="grid-cards-item-header-left-contents-case-id--link"
            :to="routerLink"
            target="_blank"
            rel="noopener noreferrer">
            <span
              v-if="item?.mlPredictionOutcome === true"
              class="grid-cards-item-header-left-contents-case-id--ml-prediction-positive grid-cards-item-header-left-contents-case-id--strong">
              {{ item.ohpDisputeId }}
            </span>
            <span
              v-else-if="item?.mlPredictionOutcome === false"
              class="grid-cards-item-header-left-contents-case-id--ml-prediction-negetive grid-cards-item-header-left-contents-case-id--strong">
              {{ item.ohpDisputeId }}
            </span>
            <span
              v-else
              class="grid-cards-item-header-left-contents-case-id--strong">
              {{ item.ohpDisputeId }}
            </span>
          </router-link>

          <icon
            v-if="
              item.autoResolutionOutcome &&
              item.autoResolutionOutcome != '<BLANK>'
            "
            v-tooltip="{
              content: item.autoResolutionOutcome
                ? item.autoResolutionOutcome == '<BLANK>'
                  ? 'BLANK'
                  : item.autoResolutionOutcome
                : '',
              classes: 'iconToolTip',
            }"
            :class-name="`${
              item.autoResolutionOutcome == '<BLANK>'
                ? 'grid-cards-item-header-left-contents-case-id--BLANK'
                : `grid-cards-item-header-left-contents-case-id--${item.autoResolutionOutcome.replaceAll(
                    ' ',
                    '-'
                  )}`
            }`"
            name="info-circle" />
          <icon
            v-if="item?.isHandedOverToCollections"
            v-tooltip="{
              content: 'Hand Over to Collections',
              classes: 'iconToolTip',
            }"
            class-name="grid-cards-item-header-left-contents-case-id--sent-to-collection"
            name="envelope" />

          <div v-if="progressPercentage > 0" class="progress-bar-wrapper">
            <span class="confidence-level-text">{{ confidenceLevel }}</span>
            <div class="progress-bar-container">
              <div class="progress-bar">
                <div
                  v-for="n in 10"
                  :key="n"
                  :class="[
                    'progress-bar-box',
                    n <= Math.ceil(progressPercentage / 10)
                      ? progressMeterClass
                      : 'progress-bar-box--empty',
                  ]"></div>
              </div>
              <span class="progress-bar-text">{{ progressPercentage }}%</span>
            </div>
          </div>
        </div>
        <div class="grid-cards-item-header-left-contents-dates">
          OHP changed at:
          <span class="grid-cards-item-header-left-contents-dates--strong">{{
            getDate(item.changedTs)
          }}</span>
          OHP created at:
          <span class="grid-cards-item-header-left-contents-dates--strong">{{
            getDate(item.createdTs)
          }}</span>
        </div>
        <div class="grid-cards-item-header-left-contents-dates">
          ODN:
          <span class="grid-cards-item-header-left-contents-dates--strong">{{
            getOdn(item.odn)
          }}</span>
          <!-- FSCM created at:
          <span class="grid-cards-item-header-left-contents-dates--strong">{{
            getDate(item.fscmCreatedTs)
          }}</span> -->
          Credit Note:
          <span class="grid-cards-item-header-left-contents-dates--strong">{{
            getCreditNote(item.creditNote)
          }}</span>
        </div>
        <div class="grid-cards-item-header-left-contents-tags">
          <dispute-case-tags
            :is-details-mode="isDetailsMode"
            :data="getDisputeCaseTagDetails(item)" />
        </div>
      </div>
      <div class="grid-cards-item-header-right-contents">
        <dispute-status
          :dispute-status="getDisputeStatus"
          :disabled="!getIsEditor || draftDisabled"
          @disputeStatusDropdown="handleDisputeStatusDropdown" />
        <div :class="[`grid-cards-item-header-right-contents-button`]">
          <Button
            label="GAM Details"
            appearance="secondary"
            icon="eye"
            icon-position="left"
            class="button-group__gam-status"
            @onClick="handleCreateGamButtonClick" />
          <div class="grid-cards-item-header-right-contents-dropdown">
            <form-select
              id="dispute-form-dropdown"
              :options="getDisputeFormDropdown"
              :disabled="updateDisabled || draftDisabled"
              :value="selectedDisputeForm"
              @input="toggleDisputeModal($event)" />
          </div>
        </div>
      </div>
    </div>
    <div class="grid-cards-item-content">
      <div
        v-for="el in disputeCardData"
        :key="el.slotKey"
        class="grid-cards-item-content-item">
        <div class="grid-cards-item-content-item-header">
          <span class="mi-24px" :class="el.icon" aria-hidden="true"></span>
          <span class="grid-cards-item-content-item-header-text">{{
            el.label
          }}</span>
        </div>
        <div
          v-tooltip="
            el.slotKey === 'closedDate' ? closedDate : item[el.slotKey]
          "
          class="grid-cards-item-content-item-content"
          :class="el.class">
          <span>
            {{ getGridItemValue(item, el) }}
          </span>
        </div>
      </div>
    </div>
    <dispute-case-details-modal
      v-if="
        disputeModalType === 'Update_casedetails' &&
        !resolutionModalLoading &&
        (resolutionStagesList || []).length &&
        (resolutionStatusList || []).length &&
        Object.keys(disputeLookupFields).length &&
        Object.keys(disputeChargecodeFields).length
      "
      :disputes-constants="disputesConstants"
      :dispute-lookup-fields="disputeLookupFields"
      :dispute-chargecode-fields="disputeChargecodeFields"
      :case-details="item"
      :dispute-modal-loading="disputeModalLoading"
      :resolution-rules-loading="resolutionRulesLoading"
      :form-disabled-list="
        resolutionRules && resolutionRules.resolutionFormUIDisableList
      "
      :form-mandatory-list="
        resolutionRules && resolutionRules.resolutionFormUIValidationList
      "
      :resolution-status-list="resolutionStatusList"
      :resolution-stages-list="resolutionStagesList"
      :resolution-button-values="resolutionButtonValues"
      :next-status-drop-down-list="nextStatusDropDownList"
      :is-s-l-a-missed="isSLAMissed"
      :reason-for-delay-options="reasonForDelayOptions"
      @updateResolutionDisputeModal="updateResolutionDisputeModal"
      @onModalClose="onModalClose"
      @createVoiceDisputes="createVoiceDisputes"
      @saveComments="saveComments"
      v-on="$listeners" />
    <bulk-alert-message-modal
      v-if="
        disputeModalType === 'Update_alert' ||
        disputeModalType === 'Update_error'
      "
      size="medium"
      :messages="
        disputeModalType === 'Update_alert'
          ? redisputeAlertMessage
          : updateErrorMessage
      "
      @onModalClose="onModalClose(true)" />
    <dispute-assignee-modal
      v-if="disputeModalType === 'Update_assignee'"
      :data="item"
      :dispute-modal-loading="disputeModalLoading"
      @updateAssigneeForm="updateAssigneeForm"
      @saveComments="saveComments"
      @onModalClose="onModalClose" />
    <dispute-tender-modal
      v-if="disputeModalType === 'Update_tender'"
      :data="item"
      :dispute-modal-loading="disputeModalLoading"
      @updateTenderForm="updateTenderForm"
      @saveComments="saveComments"
      @onModalClose="onModalClose" />
    <dispute-contact-details-modal
      v-if="disputeModalType === 'Update_contact_details'"
      :case-details="item"
      @onModalClose="onModalClose"
      @updateContactDetails="updateContactDetails" />
    <dispute-with-voice-modal
      v-if="disputeModalType === 'Update_voice'"
      :case-details="item"
      :disputes-constants="disputesConstants"
      @onModalClose="onModalClose"
      @createVoiceDisputes="createVoiceDisputes" />
    <show-gam-details-modal
      v-if="showGamDetailsModal"
      :gam-details="gamDetails"
      :dispute-modal-loading="disputeModalLoading"
      :invoice-number="item.invoiceNumber"
      @onModalClose="onGamDetailsModalClose"></show-gam-details-modal>
    <!-- Gam Pahse Auto Changes -->
    <auto-gam-resolution-modal
      v-if="false"
      :case-details="item"
      @onModalClose="onAutoGamCloseModal"></auto-gam-resolution-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Actions
import { disputeActions } from "@/actions";
import { gamActions } from "@/actions";

// Custom Components
import DisputeStatus from "@/components/DisputeStatus/DisputeStatus.vue";
import DisputeCaseTags from "@/components/DisputeCaseTags/DisputeCaseTags.vue";
import DisputeCaseDetailsModal from "@/components/DisputeUpdateModals/DisputeCaseDetailsModal/DisputeCaseDetailsModal.vue";
import DisputeAssigneeModal from "@/components/DisputeUpdateModals/DisputeAssigneeModal.vue";
import DisputeTenderModal from "@/components/DisputeUpdateModals/DisputeTenderModal.vue";
import DisputeContactDetailsModal from "@/components/DisputeUpdateModals/DisputeContactDetailsModal.vue";
import DisputeWithVoiceModal from "@/components/DisputeUpdateModals/DisputeWithVoiceModal/DisputeWithVoiceModal.vue";
import { showToast } from "@/components/common/Toast";
import BulkAlertMessageModal from "@/components/DisputeUpdateModals/BulkAlertMessageModal.vue";

// Constants
import { disputeStatusMapping } from "@/config/constant.js";
import { disputeCardData } from "@/config/disputeDataConstant.js";
import {
  updateDisputeDropDownList,
  redisputeAlertMessage,
} from "@/config/disputeUpdateModalConstant.js";
import { countryList } from "@/config/countryList.js";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import AxiosFetch from "@/utils/axios";

// Helpers
import { getMsalIdToken, isEmpty } from "@/utils/helpers.js";
import { format } from "date-fns";
import ShowGamDetailsModal from "../ShowGamDetailsModal/ShowGamDetailsModal.vue";
import Loading from "vue-loading-overlay";
import AutoGamResolutionModal from "@/components/AutoGamResolution/Modal/AutoGamResolutionModal.vue";
import { tr } from "date-fns/locale";
export default {
  name: "DisputeGridCard",
  components: {
    DisputeStatus,
    DisputeCaseTags,
    DisputeCaseDetailsModal,
    DisputeAssigneeModal,
    DisputeTenderModal,
    DisputeContactDetailsModal,
    DisputeWithVoiceModal,
    BulkAlertMessageModal,
    ShowGamDetailsModal,
    AutoGamResolutionModal,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        isDisputeEditable: true, // Default to true
      }),
    },
    employeeId: {
      type: String,
      default: "",
    },
    isDetailsMode: {
      type: Boolean,
      default: false,
    },
    disputesConstants: {
      type: Object,
      default: () => {},
    },
    disputeLookupFields: {
      type: Object,
      default: () => {},
    },
    disputeChargecodeFields: {
      type: Object,
      default: () => {},
    },
    resolutionRules: {
      type: Object,
      default: () => {},
    },
    resolutionRulesLoading: {
      type: Boolean,
      default: false,
    },
    resolutionModalLoading: {
      type: Boolean,
      default: false,
    },
    resolutionStatusList: {
      type: Array,
      default: () => {},
    },
    resolutionStagesList: {
      type: Array,
      default: () => {},
    },
    resolutionButtonValues: {
      type: Array,
      default: () => {},
    },
    nextStatusDropDownList: {
      type: Array,
      default: () => {},
    },
    isSLAMissed: {
      type: Boolean,
    },
    reasonForDelayOptions: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      countryList,
      disputeModalType: "",
      disputeFormDropdown: updateDisputeDropDownList,
      disputeModalLoading: false,
      selectedDisputeForm: updateDisputeDropDownList?.length
        ? updateDisputeDropDownList[0]
        : null,
      disputeCardData,
      redisputeAlertMessage: redisputeAlertMessage,
      updateErrorMessage: "",
      gamDetails: null,
      showGamDetailsModal: false,
      autoGamResolutionModal: false,
    };
  },
  computed: {
    ...mapGetters(["getIsEditor"]),
    ...mapGetters(["getIsSupport"]),
    closedDate() {
      return this.item.closedTs
        ? format(new Date(this.item.closedTs), "dd-MMM-yyyy hh:mm a")
        : "N/A";
    },
    routerLink() {
      return `dispute-case-details/${this.item.ohpDisputeId}`;
    },
    getDisputeStatus() {
      return {
        displayName: disputeStatusMapping[`${this.item.statusCode}`],
      };
    },
    getDisputeFormDropdown() {
      if (this.getIsSupport && this.getIsEditor) {
        return this.disputeFormDropdown;
      } else if (this.getIsSupport) {
        return this.disputeFormDropdown.filter(
          (item) => item.value === "Update_tender" || item.value === "Options"
        );
      } else {
        return this.disputeFormDropdown.filter(
          (item) => item.value !== "Update_tender"
        );
      }
    },
    updateDisabled() {
      if (this.getIsSupport || this.getIsEditor) {
        return false;
      }
      return true;
    },
    draftDisabled() {
      if (
        this.item?.isDisputeEditable === true ||
        this.item?.isDisputeEditable === "" ||
        this.item?.isDisputeEditable === null
      ) {
        return false;
      }
      return true;
    },
    progressPercentage() {
      // Replace `item.confidenceScore` with the actual field containing the percentage value
      const score = this.item.confidenceScore || 0;
      return score >= 99.99 ? 100 : score;
    },
    progressMeterClass() {
      if (this.progressPercentage >= 70) {
        return "progress-meter--green";
      } else if (
        this.progressPercentage >= 50 &&
        this.progressPercentage < 70
      ) {
        return "progress-meter--amber";
      } else {
        return "progress-meter--red";
      }
    },
    confidenceLevel() {
      if (this.progressPercentage === 100) {
        // 100% Match
        return this.item?.mlPredictionOutcome === true
          ? "Outcome:Accept - High Confidence"
          : "Outcome:Reject - High Confidence";
      } else if (
        this.progressPercentage >= 80 &&
        this.progressPercentage < 100
      ) {
        // >=80 Match
        return this.item?.mlPredictionOutcome === true
          ? "Outcome:Accept - Medium Confidence"
          : "Outcome:Reject - Medium Confidence";
      } else {
        return "Manual Review Needed"; // < 80% Match
      }
    },
  },
  mounted() {
    console.log("DisputeGridCard mounted", this.item);
    if (
      this.isDetailsMode &&
      /^[59].*$/i.test(this.item?.invoiceNumber) &&
      this.item?.caseKey
    ) {
      this.autoGamResolutionModal = this.item?.isAutoGamResolutionModal;
    } else if (
      this.isDetailsMode &&
      !/^[59].*$/i.test(this.item?.invoiceNumber)
    ) {
      this.autoGamResolutionModal = this.item?.isAutoGamResolutionModal;
    }
  },
  methods: {
    format,
    isEmpty,
    onAutoGamCloseModal() {
      this.$emit("fetchDisputeRecords");
      this.autoGamResolutionModal = false;
    },
    onGamDetailsModalClose() {
      this.showGamDetailsModal = false;
    },
    getGridItemValue(item, el) {
      if (el.slotKey === "closedDate") {
        return this.closedDate;
      }
      if (el.slotKey === "redisputeCount") {
        return item[el.slotKey] ? `${item[el.slotKey]}` : 0;
      }
      return item[el.slotKey] !== null ? item[el.slotKey] : "<BLANK>";
    },
    handleDisputeStatusDropdown() {
      if (this.item?.disputeStage?.toLowerCase() !== "redispute") {
        this.$emit("getCaseDetailsInfo", this.item);
        this.disputeModalType = "Update_casedetails";
        if (/^[59].*$/i.test(this.item?.invoiceNumber) && this.item?.caseKey) {
          this.autoGamResolutionModal = this.item?.isAutoGamResolutionModal;
        } else if (!/^[59].*$/i.test(this.item?.invoiceNumber)) {
          this.autoGamResolutionModal = this.item?.isAutoGamResolutionModal;
        }
      } else {
        this.disputeModalType = "Update_alert";
      }
    },
    getDisputeCaseTagDetails(data) {
      return {
        aging: {
          key: "Case Aging",
          value: data.caseAging ? `Case Aging: ${data.caseAging}` : null,
          status: data.caseAgingStatus ? data?.caseAgingStatus : null,
        },
        ...(this.isDetailsMode && {
          resolutionTs: {
            key: "Resolution Time",
            value: data.resolutionTat
              ? `Resolution time: ${data.resolutionTat}`
              : null,
            status: data.resolutionStatus ? data.resolutionStatus : null,
          },
        }),
        redispute: {
          key: "Redispute",
          value: data.isRedisputed,
        },
        tender: {
          key: "Tender",
          value: data.isTender,
        },
        spot: {
          key: "Spot",
          value: data.isSpot,
        },
        timeBar: {
          key: "Time Bar",
          value:
            this.getTimeBarDays(data) !== null
              ? `Time Bar: ${this.getTimeBarDays(data)} days`
              : "Time Bar: N/A",
          status:
            this.getTimeBarDays(data) !== null
              ? this.getTimeBarDays(data) >= 180
                ? "CRITICAL"
                : "LOW"
              : null,
        },
        contingencyReason: {
          key: "Contingency Reason",
          value:
            data.contingencyReason?.toLowerCase() === "strait of hormuz"
              ? "SOH"
              : null,
          status:
            data.contingencyReason?.toLowerCase() === "strait of hormuz"
              ? "HIGH"
              : null,
        },
      };
    },
    getTimeBarDays(data) {
      if (!data.createdTs || !data.billingDocumentDate) return null;
      const createdDateOnly = new Date(data.createdTs.split("T")[0]);
      const invoiceDate = new Date(data.billingDocumentDate);
      const diffMs = Math.abs(createdDateOnly - invoiceDate);
      return Math.round(diffMs / (1000 * 60 * 60 * 24));
    },
    getCountryName(data) {
      return data
        ? this.countryList[`${data.split(",").pop().trim().toLowerCase()}`]
        : "";
    },
    getDate(value) {
      return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
    },
    getCreditNote(value) {
      return value ? value : "N/A";
    },
    getOdn(value) {
      return value ? value : "N/A";
    },
    handleCreateGamButtonClick() {
      if (this.item?.invoiceNumber) {
        this.showGamDetailsModal = true;
        this.fetchAllTheGamDetails(this.item?.invoiceNumber);
      }
    },
    toggleDisputeModal({ value }) {
      this.selectedDisputeForm = { value };
      this.disputeModalType = value;
      if (this.disputeModalType === "Update_casedetails") {
        if (/^[59].*$/i.test(this.item?.invoiceNumber) && this.item?.caseKey) {
          this.autoGamResolutionModal = this.item?.isAutoGamResolutionModal;
        } else if (!/^[59].*$/i.test(this.item?.invoiceNumber)) {
          this.autoGamResolutionModal = this.item?.isAutoGamResolutionModal;
        }

        if (this.item?.disputeStage?.toLowerCase() !== "redispute") {
          this.$emit("getCaseDetailsInfo", this.item);
        } else {
          this.disputeModalType = "Update_alert";
        }
      }
    },
    onModalClose(fromAlertModal) {
      this.selectedDisputeForm = updateDisputeDropDownList?.length
        ? updateDisputeDropDownList[0]
        : null;
      this.disputeModalType = "";
      fromAlertModal && this.$emit("fetchDisputeRecords");
    },
    showErrorToast(err) {
      showToast(
        "error",
        err?.response?.data?.errorMessage ||
          err?.response?.data?.message ||
          "Unable to update Dispute, please try again!"
      );
    },
    async updateResolutionDisputeModal(payload, isbulk, successCallback) {
      try {
        this.disputeModalLoading = true;
        const { data } = await AxiosFetchForMsal(
          disputeActions.updateResolutionDisputeDetails(
            this.item.ohpDisputeId,
            payload,
            await getMsalIdToken(this)
          )
        );
        this.$emit("updateCaseDetails", data);
        if (typeof successCallback === "function") {
          successCallback();
        } else {
          this.disputeModalLoading = false;
          this.onModalClose();
        }
        showToast("success", "Dispute updated successfully!");
      } catch (err) {
        this.disputeModalLoading = false;
        this.$emit("fetchDisputeRecords");
        if (
          err.response &&
          err.response.data &&
          err.response.data.errorType === "Open-GAM"
        ) {
          this.disputeModalType = "Update_error";
          this.updateErrorMessage = { title: err.response.data.errorMessage };
        } else if (
          err.response.data.errorMessage ===
          "Resolution delay reason is mandatory"
        ) {
          this.onModalClose();
          showToast(
            "error",
            "SLA is missed for this dispute, please provide a delay reason other than 'Not Applicable' to close this case."
          );
        } else {
          this.onModalClose();
          console.log("err", err.response.data.errorMessage);
          this.showErrorToast(err);
        }
      }
    },
    async updateAssigneeForm(payload, successCallback) {
      try {
        this.disputeModalLoading = true;
        const { data } = await AxiosFetch(
          disputeActions.updateAssigneeDisputeDetails(
            payload,
            await getMsalIdToken(this)
          )
        );
        this.disputeModalLoading = false;
        this.onModalClose();
        if (data.length && data[0]?.claimStatus === "OK") {
          showToast("success", "Dispute updated successfully!");
          if (typeof successCallback === "function") {
            successCallback();
          }
          this.$emit("updateDisputes");
        } else {
          showToast("error", "Failed to update the dispute.");
        }
      } catch (err) {
        this.disputeModalLoading = false;

        this.showErrorToast(err);
        console.error(err);
      }
    },
    async updateTenderForm(payload, successCallback) {
      try {
        this.disputeModalLoading = true;
        const { data } = await AxiosFetch(
          disputeActions.updateTender(
            this.item.ohpDisputeId,
            payload,
            await getMsalIdToken(this)
          )
        );
        if (data) {
          showToast(
            "success",
            `Dispute ${this.item.ohpDisputeId} updated successfully!`
          );
          if (typeof successCallback === "function") {
            successCallback();
          }
          this.$emit("updateDisputes");
        } else {
          showToast("error", "Failed to update the dispute, please try again");
        }
        this.disputeModalLoading = false;
        this.onModalClose();
      } catch (err) {
        this.disputeModalLoading = false;
        showToast("error", "Failed to update the dispute, please try again");
        console.error(err);
      }
    },
    async createVoiceDisputes(voiceDisputeData) {
      try {
        this.disputeModalLoading = true;
        const { data } = await AxiosFetchForMsal(
          disputeActions.createVoiceDisputes(
            this.item.ohpDisputeId,
            voiceDisputeData,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.$emit("updateVoiceDisputeData", data, this.item.ohpDisputeId);
        this.$emit("updateDisputes");
        this.disputeModalLoading = false;
        this.onModalClose();
        showToast("success", "Voice dispute created successfully!");
      } catch (err) {
        this.disputeModalLoading = false;
        showToast(
          "error",
          err?.response?.data?.message ||
            "Unable to create voice Dispute, please try again!"
        );
        console.error(err);
      }
    },
    async updateContactDetails(contactDetails, successCallback) {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.updateContactDetails(
            this.item.ohpDisputeId,
            contactDetails,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        this.$emit("updateCaseDetails", data);
        if (typeof successCallback === "function") {
          successCallback();
        } else {
          this.onModalClose();
        }
        showToast(
          "success",
          "Contact Details for dispute updated successfully!"
        );
      } catch (err) {
        this.showErrorToast(err);
        console.error(err);
      }
    },
    async saveComments(payload, additionalData) {
      const { ohpDisputeId, hideLoader, isExternal } = additionalData;
      try {
        await AxiosFetchForMsal(
          disputeActions.saveComments(
            ohpDisputeId,
            isExternal,
            payload,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (this.$listeners && this.$listeners.fetchDisputeComments) {
          this.$emit("fetchDisputeComments");
        }
        if (hideLoader) {
          this.disputeModalLoading = false;
          this.onModalClose();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async fetchAllTheGamDetails(invoiceNumber) {
      this.disputeModalLoading = true;
      await Promise.allSettled([
        this.fetchGamDetailsByInvoiceNumber(invoiceNumber).then(() => {
          if (this.gamDetails?.gam_id) {
            this.fetchGamDetailsByGamId(
              this.gamDetails?.gam_id,
              this.gamDetails?.is_bulk ? "bulk" : "single"
            );
          } else {
            this.disputeModalLoading = false;
          }
        }),
      ]);
    },
    async fetchGamDetailsByInvoiceNumber(invoiceNumber) {
      try {
        const { data } = await AxiosFetchForMsal(
          gamActions.fetchGamDetailsByInvoiceNumber(
            invoiceNumber,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );

        if (data.search_records.length) {
          this.gamDetails = data.search_records[0];
        } else {
          this.gamDetails = "not-found";
        }
      } catch (error) {
        this.disputeModalLoading = false;
        showToast(
          "error",
          "Unable to fetch GAM details, please try again later"
        );
        this.showGamDetailsModal = false;
        console.error(error);
      }
    },
    async fetchGamDetailsByGamId(gamId, gamType) {
      try {
        const { data } = await AxiosFetchForMsal(
          gamActions.fetchGamDetailsByGamId(
            gamId,
            gamType,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        let waiverAmountForCharges = {
          chargeCodes: [],
          waiverAmount: [],
        };
        data?.gamChargeItems
          ?.filter(
            (chargeItems) =>
              chargeItems?.billingDocumentNo === this.item?.invoiceNumber
          )
          ?.forEach((item) => {
            waiverAmountForCharges?.chargeCodes.push(item.chargeCode);
            waiverAmountForCharges?.waiverAmount?.push(
              `${item.chargeCode} : ${item.itemWaiverAmountUsd.toFixed(2)}`
            );
          });
        this.gamDetails = {
          ...this.gamDetails,
          chargeCodes: [...new Set(waiverAmountForCharges?.chargeCodes)].join(
            ", "
          ),
          waiverAmount: waiverAmountForCharges?.waiverAmount,
        };
      } catch (error) {
        console.error(error);
      }
      this.disputeModalLoading = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.tooltip {
  &.iconToolTip {
    .tooltip-inner {
      background: var(--Gray-50);
      border: 1px solid var(--Gray-300);
      width: max-content;
      max-width: 350px;
      height: max-content;
      padding: 4px 8px;
      color: var(--Gray-700);
    }
    .tooltip-arrow {
      border-color: var(--Gray-200);
    }
  }
}
.grid-cards {
  &-item {
    background-color: var(--Gray-100);
    border-radius: 0.25rem;
    border: 0.5px solid var(--Gray-300);
    box-sizing: border-box;
    box-shadow: 0px 1px 5px var(--black-variant-1),
      0px 3px 1px -2px var(--black-variant-2),
      0px 2px 2px var(--black-variant-1);
    margin-bottom: 1rem;
    position: relative;

    &-header {
      padding: 1.5rem;
      padding-bottom: 0;
      display: flex;
      justify-content: space-between;

      &-left-contents {
        width: 65%;
        cursor: default;

        &-case-id {
          display: flex;
          align-items: center;
          font-size: 1.5rem;
          color: var(--Blue-900-Darkest);
          &--sent-to-collection {
            margin-left: 4px;
            color: rgba(0, 137, 122, 1);
          }
          &--ml-prediction-positive {
            color: rgba(0, 137, 122, 1);
          }
          &--ml-prediction-negetive {
            color: rgba(198, 40, 15, 1);
          }
          &--BLANK {
            color: rgba(240, 117, 8, 1);
          }
          &--Out-Of-Scope {
            color: rgba(0, 115, 171, 1);
          }
          &--Not-Supported {
            color: rgba(0, 115, 171, 1);
          }
          &--Potential-Reject {
            color: rgba(198, 40, 15, 1);
          }
          &--Potential-Accept {
            color: rgba(0, 137, 122, 1);
          }
          &--Exception {
            color: rgba(198, 40, 15, 1);
          }
          &--Potential-Supported {
            color: rgba(0, 137, 122, 1);
          }
          &--link {
            color: var(--Blue-900-Darkest);
          }

          &--strong {
            font-family: "Maersk Text Bold";
            cursor: pointer;
          }
        }

        &-dates {
          font-size: 0.875rem;
          margin-top: 0.5rem;
          color: var(--Gray-600);

          span:first-child {
            margin-right: 1rem;
          }

          &--strong {
            color: var(--Gray-900);
            margin-right: 1rem;
          }
        }

        &-journey {
          margin-top: 1.5rem;
          display: flex;
          align-items: flex-start;
          color: var(--Blue-900-Darkest);

          &-origin--flag {
            display: flex;
            align-items: center;

            span {
              margin-right: -0.5rem;
            }
          }

          &--separator {
            margin: 0 1rem;

            span {
              font-weight: 700;
              font-size: 2rem;
            }
          }

          &-destination--flag {
            display: flex;
            align-items: center;

            span {
              margin-right: -0.5rem;
            }
          }
        }
      }

      &-right-contents {
        display: flex;
        flex-direction: column;

        &-button {
          display: flex;
          .button-group__gam-status {
            width: 175px;
            margin-top: 16px;
            margin-right: 12px;
            .button__icon {
              color: #fff;
            }
          }
        }

        &-dropdown {
          margin-top: 1rem;
          width: 51%;
          & .form-input__field {
            padding-right: 20px !important;
          }
        }
      }
    }

    &-content {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;

      @media (min-width: 1200px) {
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
      }

      &-item {
        background: var(--Gray-50);
        padding: 0.5rem;
        border-right: 1px solid var(--Gray-300);
        border-bottom: 1px solid var(--Gray-300);

        &-header {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          cursor: default;

          span {
            margin-right: 0.75rem;
          }

          &-text {
            font-size: 0.875rem;
            color: var(--Gray-600);
          }
        }

        &-content {
          width: 95%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-left: 2.25rem;
          cursor: default;
          max-width: 12.5rem;
        }
      }
    }

    &-dispute-type {
      top: 0;
      right: -3px;
      position: absolute;
      width: 55px;
      height: 55px;
      display: flex;
      justify-content: center;
      text-transform: uppercase;

      &.cash,
      &.CASH {
        background: url("../../assets/images/icons/ab24_badge.svg") no-repeat;
      }

      h4 {
        color: var(--Gray-50);
        font-size: 12px;
        font-family: "Maersk Text Bold";
        transform: rotate(45deg);
        margin: 0;
        padding-top: 8px;
      }
    }
  }
}
</style>

<style lang="scss">
.grid-cards-item {
  & .v-select.dispute-status-dropdown {
    width: 23.5rem;
  }
}

.filter-visible {
  & .grid-cards-item-header {
    &-left-contents {
      @media (max-width: 1600px) {
        width: 45%;
      }
    }

    &-right-contents {
      @media (max-width: 1600px) {
        width: 55%;
      }
    }
  }
}

.progress-bar-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
}

.confidence-level-text {
  font-size: 0.875rem;
  font-weight: bold;
  color: #333; /* Space between text and progress bar */
}

.progress-bar-container {
  display: flex;
  align-items: center;
}

.progress-bar {
  display: flex;
  gap: 2px; /* Space between boxes */
}

.progress-bar-box {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  transition: background-color 0.3s ease;
}

.progress-bar-box--empty {
  background-color: #ccc; /* Empty box color */
}

.progress-meter--green {
  background-color: #4caf50; /* Green */
}

.progress-meter--amber {
  background-color: #ff9800; /* Amber */
}

.progress-meter--red {
  background-color: #f44336; /* Red */
}

.progress-bar-text {
  margin-left: 10px;
  font-size: 0.875rem;
  color: #333;
}
</style>
